import { render } from "./UpdateData.vue?vue&type=template&id=53025222&scoped=true&ts=true"
import script from "./UpdateData.vue?vue&type=script&lang=ts"
export * from "./UpdateData.vue?vue&type=script&lang=ts"

import "./UpdateData.vue?vue&type=style&index=0&id=53025222&scoped=true&lang=css"

import exportComponent from "/home/adminhost/web/crevent.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53025222"]])

export default __exports__